import base from "./base";
import { baseContainer } from "../index";

export const getTenantConfig = () => {
  return base.get({
    url: baseContainer.getConfig().apiEndpoints.tenantConfig,
  });
};

export const getMaintenanceInfo = () => {
  return base.getAnonymous({
    url: baseContainer.getConfig().apiEndpoints.maintenance,
  });
};
